export default __webpack_public_path__ + "static/media/fa-solid-900.81853c2f.ttf";